



































































































































































import { computed, defineComponent, getCurrentInstance, ref, toRefs, watch, nextTick } from '@vue/composition-api';
import UserLogo from '@/renderer/components/user/components/UserLogo.vue';
import FileItem from '@/renderer/components/file/FileItem.vue';
import StatusTag from '@/renderer/components/SpacePage/components/StatusTag.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import listHandler, {
  ApplyOperate,
  ApplyTableType,
  AuditStatus,
  AuditStatusCause,
} from '@/renderer/views/desktop/FileManagement/FileApply/composition/listHandler';
import { openFolderOrDirectory } from '@/renderer/scripts/utils/openFolderOrDirectory';
import ipc from '@/renderer/scripts/utils/ipc';
import { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';

interface BtnItem {
  theme: string;
  content: string;
  operate: ApplyOperate;
}
export default defineComponent({
  name: 'ApplyDetailDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    fileApplyNo: {
      type: String,
      default: '',
    },
  },
  components: {
    UserLogo,
    FileItem,
    StatusTag,
  },
  setup(props, ctx) {
    const showPopconfirm = ref(false);
    const canAuditUsers = computed(() => fileApplyDetail.canAuditUsers.map(user => user.nickname).join(';'));
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        ctx.emit('update:show', val);
      },
    });
    const vm = getCurrentInstance()?.proxy || ctx.root;
    const store = vm.$store;
    const tableType = computed(() => {
      const { tab } = vm.$router.currentRoute.query;
      let tableValue = ApplyTableType.Applying;
      switch (tab) {
        case 'applying':
          break;
        case 'myApply':
          tableValue = ApplyTableType.MyApply;
          break;
        case 'historApply':
          tableValue = ApplyTableType.HistoryApply;
          break;
        default:
          break;
      }
      return tableValue;
    });
    const { roleMap, fileApplyDetail, spacePath, methods: listMethods } = listHandler(tableType);
    const roleName = computed(() => roleMap.value[fileApplyDetail.roleId]);
    const nowRoleName = computed(() => {
      const { directoryList } = fileApplyDetail;
      const len = directoryList.length;
      if (len === 0) {
        return '-';
      }
      if (len === 1) {
        const roleIds = directoryList[0].oldRoleIds;
        if (roleIds.length === 0) {
          return '-';
        }
        if (roleIds.length === 1) {
          return roleMap.value[roleIds[0]];
        }
        return i18n_t('多种');
      }
      let roleIdArr: number[] = [];
      directoryList.forEach(dir => {
        if (dir.oldRoleIds.length) roleIdArr = [...roleIdArr, ...dir.oldRoleIds];
      });
      if (roleIdArr.length) {
        return roleIdArr.every(roleId => roleId === roleIdArr[0]) ? roleMap.value[roleIdArr[0]] : i18n_t('多种');
      }
      return '-';
    });
    const auditStatusLabel = computed(
      () =>
        [
          {
            label: i18n_t('待审批'),
            color: '#FFA100',
          },
          {
            label: i18n_t('已失效'),
            color: '#000000E5',
          },
          {
            label: i18n_t('已撤回'),
            color: '#000000E5',
          },
          {
            label: i18n_t('已拒绝'),
            color: '#ED515D',
            icon: 'apply-close',
          },
          {
            label: i18n_t('已同意'),
            color: '#00B264',
            icon: 'apply-right',
          },
        ][fileApplyDetail.auditStatus],
    );
    const isSelf = computed(() => fileApplyDetail.createdBy === store.getters.userId);
    const contextNamePhone = computed(() => {
      if (fileApplyDetail.auditStatusCause === AuditStatusCause.UserDeleted) {
        return i18n_t('用户已离职');
      }
      if (fileApplyDetail.createdByPhoneNumber) {
        return `${fileApplyDetail.createdByNickname}（${fileApplyDetail.createdByPhoneNumber}）`;
      }
      return fileApplyDetail.createdByNickname;
    });
    const departmentListString = computed(() => fileApplyDetail.createByBelongLatestTeam.name);
    // 文件路径
    const directoryPathStr = computed(() => {
      let res = [];
      if (fileApplyDetail.spaceTag === 'group') {
        res.push(`${fileApplyDetail?.group?.name}`);
      }
      res = res.concat(fileApplyDetail.directoryPath);
      return res?.join('/') || '/';
    });
    const invalidMessage = computed(() => {
      let result = '';
      switch (fileApplyDetail.auditStatusCause) {
        case AuditStatusCause.SpaceDeleted:
        case AuditStatusCause.FileDeleted:
          result = i18n_t('文件已失效');
          break;
        case AuditStatusCause.UserDeleted:
          result = i18n_t('该用户已被删除');
          break;
        case AuditStatusCause.RoleDeleted:
          result = i18n_t('申请的权限已失效');
          break;
        case AuditStatusCause.GroupDeleted:
          result = i18n_t('用户已被移出群组');
          break;
        default:
          result = '';
          break;
      }
      return result;
    });
    const methods = {
      init() {
        listMethods.onOperate(props.fileApplyNo, ApplyOperate.View);
      },
      async applyOperate(operate: ApplyOperate) {
        if (operate === ApplyOperate.Cancel) {
          showPopconfirm.value = true;
        } else {
          await listMethods.onOperate(props.fileApplyNo, operate);
          ipc.emit(ipc.RENDERER_EVENTS_MAP.APPLY_LIST_FRESH);
          innerShow.value = false;
          showPopconfirm.value = false;
        }
      },
      async confirmCancel(
        val: string,
        context: {
          [key: string]: string;
        },
      ) {
        if (context && context.trigger === 'confirm') {
          await listMethods.onOperate(props.fileApplyNo, ApplyOperate.Cancel);
          ipc.emit(ipc.RENDERER_EVENTS_MAP.APPLY_LIST_FRESH);
          innerShow.value = false;
          showPopconfirm.value = false;
        }
        if (context && context.trigger === 'cancel') {
          showPopconfirm.value = false;
        }
      },
      openOriginDirectroy(item: SMH.DirectoryItem) {
        if (!item.isValid) {
          tips.error(i18n_t('已被删除，请前往误删恢复找回'));
          return;
        }
        innerShow.value = false;
        nextTick(() => {
          const directoryItem = Object.assign(item, {
            spaceTag: fileApplyDetail.spaceTag,
            isUserBelongSpace: fileApplyDetail.isUserBelongSpace,
            group: fileApplyDetail.group,
            team: fileApplyDetail.team,
            user: fileApplyDetail.user,
            spaceId: fileApplyDetail.spaceId,
            relatedToMePath: fileApplyDetail.relatedToMePath,
          });
          openFolderOrDirectory({
            item: directoryItem,
            isOpenFolder: false,
            targetRouteName: '',
            currentRouteName: 'fileApply',
          });
        });
      },
    };
    watch(innerShow, val => {
      if (val) {
        methods.init();
      }
    });
    return {
      ...toRefs(fileApplyDetail),
      spacePath,
      roleMap,
      roleName,
      nowRoleName,
      auditStatusLabel,
      canAuditUsers,
      isSelf,
      innerShow,
      AuditStatus,
      ApplyOperate,
      AuditStatusCause,
      showPopconfirm,
      contextNamePhone,
      departmentListString,
      directoryPathStr,
      invalidMessage,
      ...methods,
    };
  },
});
